import presignedExport from '../../services/auth/presignedExport';

angular.module('clientDashboardApp').factory('localSearchAnalyticsService', function ($http) {
  const getInsights = (provider, groupId, startDate, endDate) => $http({
    url: `/v5/searchAnalytics/${groupId}`,
    method: "GET",
    params: {provider, startDate, endDate},
  })

  const getDetailedLocationInsights = (provider, groupId, startDate, endDate) => $http({
    url: `/v5/searchAnalytics/locations/${groupId}`,
    method: "GET",
    params: {provider, startDate, endDate},
  })

  const getProviders = () => $http({
    url: `/v5/searchAnalytics/providers/`,
    method: "GET"
  })

  const getDetailedGroupInsights = (provider, groupId, startDate, endDate) => $http({
    url: `/v5/searchAnalytics/groups/${groupId}`,
    method: "GET",
    params: {provider, startDate, endDate},
  })

  const exportLocations = (provider, groupId, startDate, endDate) => {
    presignedExport.downloadExport('/v5/searchAnalytics/dailyReport/' + groupId, {provider, startDate, endDate} ).then((resp) => {
      return resp;
    });
  }

  const exportStoreComparison = (provider, groupId, startDate, endDate, byGroups) => {
    presignedExport.downloadExport('/v5/searchAnalytics/storeComparisonReport/' + groupId, {provider, startDate, endDate, byGroups} ).then((resp) => {
      return resp;
    });
  }

  const snapshotSummary = (groupId, startDate, endDate) => $http({
    url: `/v5/searchAnalytics/snapshotSummary/${groupId}`,
    method: "GET",
    params: {startDate, endDate}
  })

  return {
    getInsights,
    getDetailedLocationInsights,
    getDetailedGroupInsights,
    exportLocations,
    exportStoreComparison,
    getProviders,
    snapshotSummary,
  }
})
